import { render, staticRenderFns } from "./EditaDocumentoFromComponent.vue?vue&type=template&id=db49f582&scoped=true"
import script from "./EditaDocumentoFromComponent.vue?vue&type=script&lang=js"
export * from "./EditaDocumentoFromComponent.vue?vue&type=script&lang=js"
import style0 from "./EditaDocumentoFromComponent.vue?vue&type=style&index=0&id=db49f582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db49f582",
  null
  
)

export default component.exports